var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "section grid-view shipping-form",
      staticStyle: { padding: "10px 20px" }
    },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          {
            staticClass: "operations",
            staticStyle: { "margin-bottom": "5px" }
          },
          [
            _c("div", { staticClass: "triggers" }, [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "new')",
                        disabled: !_vm.isEdit,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.showEditDialog(true)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "edit",
                        disabled: !_vm.isEdit,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.showEditDialog(false)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { disabled: !_vm.isEdit, type: "danger" },
                      on: { click: _vm.remove }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                  )
                ],
                1
              )
            ])
          ]
        ),
        _c(
          "div",
          { staticClass: "grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              attrs: {
                "grid-params": _vm.girdParams,
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.girdParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.girdParams = $event
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "shipping-form",
          attrs: {
            visible: _vm.editDialog.visible,
            title: _vm.editDialog.title,
            width: "400px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "120px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.BranchCMP") } },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "branchId",
                          "select-type": _vm.selectTypeNames.basic_data_Office,
                          filterable: "",
                          clearable: false,
                          "callback-params": { key: "branchId" },
                          "callback-method-type": "value",
                          "tag-name": "code",
                          "default-value": _vm.editDialog.form.branchId
                        },
                        on: { parentCallBack: _vm.selectCargoItem }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.ediSenderCode") } },
                    [
                      _c("el-input", {
                        attrs: { no: "sendCode" },
                        model: {
                          value: _vm.editDialog.form.sendCode,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "sendCode", $$v)
                          },
                          expression: "editDialog.form.sendCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.ediReceiverCode") } },
                    [
                      _c("el-input", {
                        attrs: { no: "receiveCode" },
                        model: {
                          value: _vm.editDialog.form.receiveCode,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "receiveCode", $$v)
                          },
                          expression: "editDialog.form.receiveCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "CNCode" } },
                    [
                      _c("el-input", {
                        attrs: { no: "cnCode" },
                        model: {
                          value: _vm.editDialog.form.cnCode,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "cnCode", $$v)
                          },
                          expression: "editDialog.form.cnCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isSalesForSzfs,
                          expression: "!isSalesForSzfs"
                        }
                      ],
                      attrs: { label: _vm.$t("queryJob.bookingAgent") }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "bookingAgent",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": { bookingAgent: true, active: true },
                          filterable: "",
                          "callback-params": { key: "bookingAgentId" },
                          "callback-method-type": "value",
                          "default-value": _vm.editDialog.form.bookingAgentId
                        },
                        on: { parentCallBack: _vm.selectCargoItem }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.bookingPartyCode") } },
                    [
                      _c("el-input", {
                        attrs: { no: "bookingPartyCode" },
                        model: {
                          value: _vm.editDialog.form.bookingPartyCode,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.editDialog.form,
                              "bookingPartyCode",
                              $$v
                            )
                          },
                          expression: "editDialog.form.bookingPartyCode"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "save", type: "primary" },
                  on: { click: _vm.saveShipping }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.editDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }